import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { StripeSelect } from './types'
import { RootState } from '../../types'

export const state: StripeSelect = {
  stripe: null,
  accountId: null
}

const namespaced = true

export const stripe: Module<StripeSelect, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
